<template>
  <div class="actions-collapsed-list">
    <a
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
        tooltip-placement="right"
        uib-tooltip="Cancel"
      />
    </a>

    <div class="action-icon">
      <a
        class="btn btn-list-function"
        @click="showForm"
      >
        <i
          v-tooltip.bottom.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <div class="action-icon">
      <a
        :disabled="disabled"
        class="btn btn-list-function"
        @click="deleteWebhook(currentWebhook)"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </a>
    </div>
    <ChangeLogObjectButtonAction
      :is-disabled="disabled"
      :object-id="currentWebhook.id"
      :object-name="currentWebhook.incomingQueryStringName"
      object-type="Webhook"
    />
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default {
  name: 'WebhookActions',
  components: {
    ChangeLogObjectButtonAction
  },
  props:{
    currentWebhook: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showPopOver: false,
      placement: 'bottomleft'
    };
  },
  computed: {
    currentUserName() { return accountsService.currentUserName; }
  },
  methods:{
    togglePopover() {
      this.showPopOver = !this.showPopOver;
    },
    deleteWebhook(webhook) {
      if (!this.disabled) {
        this.$emit('confirm-delete', webhook);
      }
    },
    showForm() {
      this.$emit('edit', this.currentWebhook.id);
    },
    collapseActions() {
      this.$emit('collapse-actions', this.currentWebhook.id);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss">
form.user {
  .multi-select-lg {
    width: 100%;
  }

  .v-select .vs__selected {
    height: 32px;
    padding: 8px 8px 7px 10px;
    border-bottom: 1px solid transparent;
  }
}

.popover.left > .arrow:after {
  border-left-color: var(--component-in-app-notifications__popover)
}
</style>